<template>
  <div>
    <a-page-header style="width: 105%; margin-left: -20px" title="">
      <template slot="tags">
        <a-breadcrumb>
          <a-breadcrumb-item href="">
            <a-icon type="pie-chart"/>
            <span>{{ $t("message.memberCenter.memberCenter") }}</span>
          </a-breadcrumb-item>
          <a-breadcrumb-item href="">
            <a-icon type="usergroup-add"/>
            <span>{{ $t("message.memberCenter.addRules") }}</span>
          </a-breadcrumb-item>
        </a-breadcrumb>
      </template>
    </a-page-header>
    <a-spin :spinning="spinning">
    <a-card style="min-height: calc(100vh - 141px);">
      <div class="add-member-title mb16">{{ $t("message.memberCenter.resetConfiguration") }}</div>
      <a-row>
        <a-col :md="{ span: 24 }" :lg="{ span: 13 }" :xl="{ span: 13 }" :xxl="{ span: 13 }">
          <a-form-model ref="addFormRef" :model="form" :labelCol="{ span: 4 }"
                        :wrapperCol="{ span: 18 }" :rules="rules">
            <a-form-model-item :label="$t('message.memberCenter.resetRules')" prop="rulesName">
              <a-radio-group :size="$globalSize" v-model="form.clearRule">
                <a-radio :value="0">
                  {{ $t('message.memberCenter.doNotReset') }}
                </a-radio>
                <a-radio :value="1">
                  {{ $t('message.memberCenter.naturalYearReset') }}
                </a-radio>
                <a-radio :value="2">
                  {{ $t('message.memberCenter.relativeValidityPeriodOfPoints') }}
                </a-radio>
              </a-radio-group>
              <div class="flex grid-gap-8 align-items-center">
                <a-input-number :size="$globalSize" v-model="form.times"  :min="1" :max="100000"/>
                <a-select :size="$globalSize" style="width: 100px;" v-model="form.timeType"
                          :placeholder="$t('message.commonUsage.day')"
                          >
                  <a-select-option value="YEARS">{{ $t('message.commonUsage.year') }}</a-select-option>
                  <a-select-option value="MONTHS">{{ $t('message.commonUsage.month') }}</a-select-option>
                  <a-select-option value="DAYS">{{ $t('message.commonUsage.day') }}</a-select-option>
                  <!-- 其他选项 -->
                </a-select>
                {{ $t('message.memberCenter.expiresAfter') }}
              </div>
            </a-form-model-item>
            <div class="add-member-title mb16">{{ $t('message.memberCenter.displayCopywritingConfiguration') }}</div>

            <a-form-model-item :label="$t('message.memberCenter.displayCopywriting')">
              <a-input :size="$globalSize"  v-model="form.integralWayText" style="width: 320px;"></a-input>
              <div class="sub-title">{{ $t('message.memberCenter.subtitle') }}</div>
            </a-form-model-item>

          </a-form-model>

        </a-col>
      </a-row>
      <a-row>
        <a-col :md="{ span: 24 }" :lg="{ span: 8 }" :xl="{ span: 8 }" :xxl="{ span: 8 }">
          <div class="add-member-title mb16">{{ $t("message.memberCenter.pointEventTypeConfig") }}</div>
          <div class="sub-title-1">{{ $t("message.memberCenter.subtitle1") }}</div>
          <a-radio-group :size="$globalSize" v-model="form.limit">
            <a-radio :style="radioStyle" :value="1">
              {{ $t("message.memberCenter.noLimit") }}
            </a-radio>
            <a-radio :style="radioStyle" :value="2">
              {{ $t("message.memberCenter.fixedTimeLimit") }}
              <a-select :size="$globalSize" style="width: 98px;" v-model="form.limitValue.timeType"
                        :placeholder="$t('message.memberCenter.natureWeek')"
                        >
                <a-select-option value="WEEKS">自然周</a-select-option>
                <a-select-option value="MONTHS">自然月</a-select-option>
                <a-select-option value="QUARTER">季度</a-select-option>
                <!-- 其他选项 -->
              </a-select>
              {{ $t("message.memberCenter.maximumObtainableWithin") }}

              <a-input :size="$globalSize" style="width: 80px;" class="ml8"  ref="userNameInput"
                       v-model="form.limitValue.timeValue">

              </a-input>
              {{ $t("message.memberCenter.points") }}
            </a-radio>
          </a-radio-group>
        </a-col>
      </a-row>

      <a-divider></a-divider>
      <a-row>
        <a-col :md="{ span: 24 }" :lg="{ span: 8 }" :xl="{ span: 8 }" :xxl="{ span: 8 }">
          <div class="flex grid-gap-16 ">
            <a-button  :size="$globalSize"  class="form-submit-btn"  @click="visible = true">{{
                $t('message.commonUsage.save')
              }}
            </a-button>
            <a-button  :size="$globalSize"  class="form-cancel-btn"  @click="$emit('close')">{{
                $t('message.commonUsage.cancel')
              }}
            </a-button>
          </div>
        </a-col>
      </a-row>
    </a-card>
    </a-spin>
    <a-modal
        :title="$t('message.commonUsage.addConfirmTitle')"
        :visible="visible"
        @cancel="handleCancel"
        :footer="null"
        centered
        :bodyStyle="{'padding-left':'24px'}"
    >
      <div class="confirm-modal-body w100 flex justify-content-center align-items-center">{{ $t('message.commonUsage.addConfirmContent') }}</div>
      <div class="w100 flex justify-content-center grid-gap-16 mt24">
        <a-button  :size="$globalSize"  class="form-submit-btn"  @click="handleOk" :loading="confirmLoading">{{
            $t('message.commonUsage.confirm')
          }}
        </a-button>
        <a-button  :size="$globalSize"  class="form-cancel-btn"  @click="handleCancel">{{
            $t('message.commonUsage.cancel')
          }}
        </a-button>
      </div>
    </a-modal>
  </div>
</template>

<script>
import {questionIcon} from '@/components/richIcon/index'
import integralRuleApi from "@/interface/pages/memberCenter/integralRuleApi";

export default {
  name: "BaseConfig",
  components: {
    questionIcon
  },
  data() {
    return {
      radioStyle: {
        display: 'block',
        height: '40px',
        lineHeight: '40px',
      },
      visible: false,
      confirmLoading: false,
      spinning: false,
      form: {
        clearRule: 0,
        integralWayText: '',
        timeType: 1,
        times: '',
        eventTypeConfig: {
          timeType: '',
          timeValue: ''
        },
        limit:1,
        limitValue:{}
      },
      rules: {}
    }
  },
  watch: {
    'form.limit': {
      handler(newVal, oldVal) {
        if (newVal === 1) {
          this.form.eventTypeConfig = null
        }
      },
    }
  },
  mounted() {
    this.getBaseConfig();
  },
  methods: {
    handleOk(e) {
      this.confirmLoading = true;
      this.saveBaseConfig()
    },
    handleCancel(e) {
      this.visible = false;
    },
    async getBaseConfig() {
      this.spinning = true;
      const {data: res} = await integralRuleApi.getBaseConfig(this, {});
      if (res.code === 0) {
        this.form = {
          ...res.data,
          limit: res.data.eventTypeConfig === null ? 1 : 2,
          limitValue: res.data.eventTypeConfig ? res.data.eventTypeConfig : {}
        };
      } else {
        this.$message.error(res.msg);
      }
      this.spinning = false;
    },
    async saveBaseConfig() {
      this.spinning = true;
      const {data: res} = await integralRuleApi.saveBaseConfig(this, {
        data: {
          ...this.form,
          eventTypeConfig: this.form.limit === 1 ? null : this.form.limitValue
        }
      });
      if (res.code === 0) {
        this.$message.success(this.$t('message.commonUsage.successfullySaved'))
        this.visible = false
        this.confirmLoading = false
        this.$emit('close')
      } else {
        this.$message.error(res.msg);
      }
      this.spinning = false;
    },
  }
}
</script>

<style scoped lang="less">
.add-member-title {
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0em;
  color: rgba(0, 0, 0, 0.9);
}

.form-sub-title {
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0em;
  color: rgba(0, 0, 0, 0.6);
}

::v-deep .ant-modal-title {
  text-align: left;
}

.sub-title {
  font-family: PingFang SC;
  font-size: 12px;
  font-weight: normal;
  line-height: 24px;
  letter-spacing: 0em;
  color: rgba(0, 0, 0, 0.6);

}

.sub-title-1 {
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: normal;
  line-height: 24px;
  letter-spacing: 0em;
  color: rgba(0, 0, 0, 0.6);
}
</style>